import { useState } from 'react';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { EmptyIndicator, Pagination, Search, User } from 'components/common';
import { Box, BoxRow } from 'components/common/box';
import { StatCount } from 'components/common/stats';

import type { User as IUser } from 'shared-types';

const UsersLimited = () => {
  const { messages } = useReduxState();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const { data, loading } = useApiData({
    url: `/admin/users-user/?page=${page}&search=${search}`
  });

  const handleSearch = async ({ search }) => {
    setPage(1);
    setSearch(search);
  };

  return (
    <div>
      <Box
        loading={loading}
        headerContent={
          <Search
            onSearch={handleSearch}
            placeholder={messages.usersSearchUsers}
          />
        }
        padding={0}
        title={
          <>
            <StatCount
              isLarge={true}
              style={{ display: 'inline-block', marginRight: 5 }}
              value={data?.usersCount}
            />
            {messages.usersFiltersUsers}
          </>
        }
      >
        {!data?.users?.length && !loading ? (
          <EmptyIndicator icon="user" title={messages.usersNoUsersFound} />
        ) : (
          data?.users.map((user: IUser) => (
            <BoxRow key={user?.id}>
              <User
                enableProfileLink={true}
                style={{ marginRight: 5 }}
                user={user}
              />
            </BoxRow>
          ))
        )}
      </Box>

      <Pagination
        currentPage={page}
        numberOfPages={data?.pages || 1}
        onPageChange={({ page }) => setPage(page)}
      />
    </div>
  );
};

export default UsersLimited;
